export const ORIGIN_URL_QUERY = 'boomerang'
